export const menuCategories = [
  {
    id: "signature",
    label: "Signature",
    items: [
      { name: "Citrico", price: 10, type: "Iced", image: "https://static.readdy.ai/image/fbde66c2ce10a2a0ab5b61c49fd1cd3d/71d2fb520f9241ab8b906f78506daed8.png" },
      { name: "Spanish Latte", price: 12, type: "Iced", image: "https://public.readdy.ai/ai/img_res/edited_72f9b155e6dde6315406453af4c10acb_4d07ac22.jpg" },
      { name: "Mango Chocolate", price: 13, type: "Iced", image: "https://static.readdy.ai/image/fbde66c2ce10a2a0ab5b61c49fd1cd3d/6d903a8b2885122f51a50bdda073916c.png" },
      { name: "Black Forest", price: 13, type: "Iced", image: "https://static.readdy.ai/image/fbde66c2ce10a2a0ab5b61c49fd1cd3d/bb7b6e125852bc4ac8280d1323f07830.png" },
    ],
  },
  {
    id: "coffee",
    label: "Coffee",
    items: [
      { name: "Americano", price: 8, type: "Hot / Iced", image: "https://storage.helloreaddy.io/project_files/25a238db-f2d3-4f6d-baeb-fc58209ea611/f75afeb4-4556-4bd2-a154-de0212d3bcb9_compressed_lv_0_20260731065642.webp" },
      { name: "Cappuccino", price: 10, type: "Hot / Iced", image: "https://storage.helloreaddy.io/project_files/25a238db-f2d3-4f6d-baeb-fc58209ea611/dfbf706a-4c59-47d4-a0b2-ee1d92e4cc1d_compressed_lv_0_20260731072725.webp" },
      { name: "Mocha", price: 11, type: "Hot / Iced", image: "https://storage.helloreaddy.io/project_files/25a238db-f2d3-4f6d-baeb-fc58209ea611/adb6a27b-68b0-4465-8983-fc1f4f012001_compressed_1785346669433.webp" },
      { name: "Latte", price: 10, type: "Hot / Iced", image: "https://storage.helloreaddy.io/project_files/25a238db-f2d3-4f6d-baeb-fc58209ea611/25b18ee1-c029-4d17-be59-64e44eacc74a_compressed_lv_0_20260730013436.webp" },
    ],
  },
  {
    id: "non-coffee",
    label: "Non-Coffee",
    items: [
      { name: "Cookies and Cream", price: 15, type: "Iced", image: "https://storage.helloreaddy.io/project_files/25a238db-f2d3-4f6d-baeb-fc58209ea611/f1200a17-0efd-4dce-8a9d-1b92c736d79f_compressed_lv_0_20260731081510.webp" },
      { name: "Pine Berry Frappe", price: 12, type: "Iced", image: "https://storage.helloreaddy.io/project_files/25a238db-f2d3-4f6d-baeb-fc58209ea611/d64e5780-3dc7-41be-9f39-f2cc8593bfd6_compressed_lv_0_20260730013255.webp" },
      { name: "Chocolate Frappe", price: 12, type: "Iced", image: "https://storage.helloreaddy.io/project_files/25a238db-f2d3-4f6d-baeb-fc58209ea611/bbed79ed-1167-4c59-8b77-2a91dee65213_compressed_lv_0_20260731083833.webp" },
      { name: "Blushing Lychee Tea", price: 11, type: "Iced", image: "https://public.readdy.ai/ai/img_res/edited_42ef9ed8d50a622d6b3572c6b75e0060_b8508808.jpg" },
      { name: "Citrus & Silk Tea", price: 10, type: "Iced", image: "https://storage.helloreaddy.io/project_files/25a238db-f2d3-4f6d-baeb-fc58209ea611/dbd6f240-88d8-4c8d-bcc0-8feac5fe519b_compressed_lv_0_20260731084418.webp" },
      { name: "Monsoon Bloom Tea", price: 10, type: "Iced", image: "https://storage.helloreaddy.io/project_files/25a238db-f2d3-4f6d-baeb-fc58209ea611/ada91ef4-8f9a-439b-b349-4283a9252fa9_compressed_lv_0_20260731085106.webp" },
      { name: "Berry Banana Blast Mix Fruit", price: 15, type: "Iced", image: "https://storage.helloreaddy.io/project_files/25a238db-f2d3-4f6d-baeb-fc58209ea611/c0548756-a84f-4957-9f97-2bf4ef8193a5_compressed_lv_0_20260731084014.webp" },
    ],
  },
  {
    id: "flavoured",
    label: "Flavoured",
    items: [
      { name: "Salted Caramel", price: 12, type: "Hot / Iced", image: "https://storage.helloreaddy.io/project_files/25a238db-f2d3-4f6d-baeb-fc58209ea611/f6a8ec4c-e81d-421d-b832-9ad858a7bf21_compressed_lv_0_20260731085504.webp" },
      { name: "Caramel Macchiato", price: 13, type: "Hot / Iced", image: "https://storage.helloreaddy.io/project_files/25a238db-f2d3-4f6d-baeb-fc58209ea611/f6a8ec4c-e81d-421d-b832-9ad858a7bf21_compressed_lv_0_20260731085504.webp" },
      { name: "Hazelnut Latte", price: 12, type: "Hot / Iced", image: "https://storage.helloreaddy.io/project_files/25a238db-f2d3-4f6d-baeb-fc58209ea611/dfbf706a-4c59-47d4-a0b2-ee1d92e4cc1d_compressed_lv_0_20260731072725.webp" },
      { name: "Vanilla Latte", price: 12, type: "Hot / Iced", image: "https://storage.helloreaddy.io/project_files/25a238db-f2d3-4f6d-baeb-fc58209ea611/dfbf706a-4c59-47d4-a0b2-ee1d92e4cc1d_compressed_lv_0_20260731072725.webp" },
    ],
  },
  {
    id: "matcha",
    label: "Matcha",
    items: [
      { name: "Matcha", price: 12, type: "Hot / Iced", image: "https://storage.helloreaddy.io/project_files/25a238db-f2d3-4f6d-baeb-fc58209ea611/14d8afb8-c6a2-4029-8796-1571fd0c2ff2_compressed_lv_0_20260731082346.webp" },
      { name: "Strawberry Matcha", price: 13, type: "Iced", image: "https://storage.helloreaddy.io/project_files/25a238db-f2d3-4f6d-baeb-fc58209ea611/a24c0cfd-c6cd-4f24-9f14-e02d9ff442d3_compressed_lv_0_20260731081834.webp" },
      { name: "Mango Matcha", price: 15, type: "Iced", image: "https://storage.helloreaddy.io/project_files/25a238db-f2d3-4f6d-baeb-fc58209ea611/f1ae25dd-f5b0-4ec6-80c6-8c7458b17f3a_compressed_IMG_20260729_224628_316.webp" },
    ],
  },
];

export const addOns = [
  { name: "Extra Shot", price: 3 },
  { name: "Oat Milk", price: 2 },
  { name: "Extra Syrup", price: 1 },
  { name: "Extra Puree", price: 2 },
  { name: "Whipped Cream", price: 2 },
  { name: "Honey", price: 1 },
];

export const eventPackages = [
  {
    id: "a",
    name: "Package A",
    price: 5,
    perCup: true,
    drinks: ["Americano", "Latte"],
    bonus: null,
    popular: false,
  },
  {
    id: "b",
    name: "Package B",
    price: 6,
    perCup: true,
    drinks: ["Americano", "Latte", "Matcha"],
    bonus: "Free Hazelnut & Vanilla",
    popular: false,
  },
  {
    id: "c",
    name: "Package C",
    price: 6,
    perCup: true,
    drinks: ["Americano", "Latte", "Chocolate"],
    bonus: "Free Hazelnut & Vanilla",
    popular: false,
  },
  {
    id: "d",
    name: "Package D",
    price: 7,
    perCup: true,
    drinks: ["Americano", "Latte", "Chocolate", "Matcha"],
    bonus: "Free Hazelnut & Vanilla",
    popular: true,
  },
];

export const eventTypes = [
  { icon: "ri-heart-line", label: "Wedding" },
  { icon: "ri-home-line", label: "Private Event" },
  { icon: "ri-cake-line", label: "Birthday Party" },
  { icon: "ri-briefcase-line", label: "Projects & Collab" },
];

export const testimonials = [
  {
    name: "Jannah M.",
    handle: "@jannahmardina",
    text: "Finally, legit specialty coffee in Bukit Raja! The Iced Spanish Latte is to die for. The baristas are super friendly and the whole vibe is just immaculate. My daily go-to now!",
    avatar: "https://static.readdy.ai/image/fbde66c2ce10a2a0ab5b61c49fd1cd3d/ad188468de348bb31cf86e2cb3cd0fbd.png",
  },
  {
    name: "Hafiz M.",
    handle: "@hafizmuhammad",
    text: "Best coffee truck in Shah Alam hands down. The Matcha Strawberry is something else never had anything like it. Prices are super reasonable for the quality. Highly recommended!",
    avatar: "https://static.readdy.ai/image/fbde66c2ce10a2a0ab5b61c49fd1cd3d/6803e3fd55b69d94debeb4dce5f8bbf9.png",
  },
  {
    name: "Sarah L.",
    handle: "@sarah.glaz",
    text: "We booked BeanhoodBrew for our office event and it was a hit! The team was professional, the drinks were amazing, and everyone kept talking about it for weeks. 10/10 would book again.",
    avatar: "https://static.readdy.ai/image/fbde66c2ce10a2a0ab5b61c49fd1cd3d/e2a0f67b6be2971b43adeebe4e640611.png",
  },
];

export const galleryImages = [
  {
    src: "https://static.readdy.ai/image/fbde66c2ce10a2a0ab5b61c49fd1cd3d/cd0ea213e8acf3aca05fbbd4065b2a4e.png",
    alt: "BB Coffee event experience with crowd of customers",
    caption: "BB Coffee event experience with crowd of customers",
    large: true,
  },
  {
    src: "https://static.readdy.ai/image/fbde66c2ce10a2a0ab5b61c49fd1cd3d/0cc6c03234f890e482c602c2dc8333ef.png",
    alt: "BB Coffee booth setup at event experience",
    caption: "BB Coffee booth setup at event experience",
    large: false,
  },
  {
    src: "https://static.readdy.ai/image/fbde66c2ce10a2a0ab5b61c49fd1cd3d/5d3e7b49d84ab5772eb3c42d508d0abe.png",
    alt: "Baristas serving at BB Coffee event experience",
    caption: "Baristas serving at BB Coffee event experience",
    large: false,
  },
  {
    src: "https://static.readdy.ai/image/fbde66c2ce10a2a0ab5b61c49fd1cd3d/fd656164a039da7634075b6502588bf0.png",
    alt: "Customers lining up at BB Coffee booth",
    caption: "Customers lining up at BB Coffee booth",
    large: false,
  },
  {
    src: "https://static.readdy.ai/image/fbde66c2ce10a2a0ab5b61c49fd1cd3d/52395983440646b0510288d71c422caa.png",
    alt: "Busy BB Coffee stall serving drinks at event experience",
    caption: "Busy BB Coffee stall serving drinks at event experience",
    large: false,
  },
];

export const whyUsFeatures = [
  {
    icon: "ri-fire-line",
    title: "Freshly Roasted Coffee",
    text: "We roast our own beans in small batches. Every cup starts with beans roasted to perfection never stale, never mass-produced.",
  },
  {
    icon: "ri-money-dollar-circle-line",
    title: "Affordable Pricing",
    text: "Premium quality doesn't have to come with a premium price tag. Great coffee should be accessible to everyone.",
  },
  {
    icon: "ri-award-line",
    title: "Premium Ingredients",
    text: "From single-origin beans to high-quality milk and syrups we never compromise on what goes into your drink.",
  },
  {
    icon: "ri-timer-line",
    title: "Fast Service",
    text: "We know you're busy. Our streamlined process means you get your handcrafted drink fast without sacrificing quality.",
  },
  {
    icon: "ri-truck-line",
    title: "Convenient Location",
    text: "Right at Pusat Perniagaan Bukit Raja easy to find, easy to park, easy to grab your daily caffeine fix.",
  },
  {
    icon: "ri-hearts-line",
    title: "Great Experience",
    text: "From the first greeting to the last sip, we make sure every visit puts a smile on your face. That's the BeanhoodBrew promise.",
  },
];

export const aboutFeatures = [
  {
    icon: "ri-fire-line",
    title: "Freshly Roasted Beans",
    text: "We roast our own beans in small batches to ensure every cup bursts with rich, aromatic flavour.",
  },
  {
    icon: "ri-money-dollar-circle-line",
    title: "Affordable Prices",
    text: "Premium handcrafted coffee that won't break the bank. Quality meets affordability in every sip.",
  },
  {
    icon: "ri-map-pin-line",
    title: "Easy to Reach Location",
    text: "Conveniently parked at Pusat Perniagaan Bukit Raja, right in the heart of Shah Alam.",
  },
  {
    icon: "ri-cup-line",
    title: "Handcrafted Drinks",
    text: "Every drink is made to order with care and precision by passionate baristas who love what they do.",
  },
  {
    icon: "ri-emotion-happy-line",
    title: "Friendly Service",
    text: "We believe great coffee tastes even better when served with a warm smile and genuine conversation.",
  },
];